module.exports = __webpack_public_path__ + "img/logoPRE.56ee0148.svg";